export default function () {
  return {
    pushToken: ''
  }
}
